import GroupsIcon from '@mui/icons-material/Groups';
import BadgeIcon from '@mui/icons-material/Badge';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import DescriptionIcon from '@mui/icons-material/Description';
import AssessmentIcon from '@mui/icons-material/Assessment';
import type { NavigationItem, ModuleInfo } from '@core/router/types';
import { Permissions } from '@core/auth/permissions';

/**
 * Human Resources Module Information
 *
 * Used by the sidebar module switcher.
 */
export const humanResourcesModuleInfo: ModuleInfo = {
  id: 'ljudski-resursi',
  labelKey: 'modules.humanResources.name',
  icon: <GroupsIcon />,
  basePath: '/ljudski-resursi',
  accessPermission: Permissions.HumanResources.Employees.Read,
  order: 3,
};

/**
 * Human Resources Module Navigation Items
 */
export const humanResourcesNavigation: NavigationItem[] = [
  {
    label: 'Zaposleni',
    labelKey: 'humanResources.nav.employees',
    path: '/ljudski-resursi/zaposleni',
    icon: <BadgeIcon />,
    permission: Permissions.HumanResources.Employees.Read,
  },
  {
    label: 'Godišnji i odsustva',
    labelKey: 'humanResources.nav.absences',
    path: '/ljudski-resursi/odsustva-i-odmori',
    icon: <EventBusyIcon />,
    permission: Permissions.HumanResources.EmployeeAbsences.Read,
  },
  {
    label: 'Organizaciona struktura',
    labelKey: 'humanResources.nav.workUnits',
    path: '/ljudski-resursi/organizaciona-struktura',
    icon: <AccountTreeIcon />,
    permission: Permissions.HumanResources.WorkUnits.Read,
  },
  {
    label: 'Sistematizacija',
    labelKey: 'humanResources.nav.jobPositions',
    path: '/ljudski-resursi/sistematizacija',
    icon: <WorkOutlineIcon />,
    permission: Permissions.HumanResources.JobPositions.Read,
  },
  {
    label: 'HR dokumenta',
    labelKey: 'humanResources.nav.documents',
    path: '/ljudski-resursi/dokumenti',
    icon: <DescriptionIcon />,
    permission: Permissions.HumanResources.Catalogs.Manage,
  },
  {
    label: 'Izveštaji',
    labelKey: 'humanResources.nav.reports',
    path: '/ljudski-resursi/izvestaji',
    icon: <AssessmentIcon />,
    permission: Permissions.HumanResources.Reports.Run,
  },
  {
    label: 'Katalozi',
    labelKey: 'humanResources.nav.catalogs',
    icon: <MenuBookIcon />,
    permission: Permissions.HumanResources.Catalogs.Manage,
    children: [
      {
        label: 'Obrazovanje',
        labelKey: 'humanResources.catalogs.educationCatalogs.navLabel',
        path: '/ljudski-resursi/katalozi/obrazovanje',
        permission: Permissions.HumanResources.Catalogs.Manage,
      },
      {
        label: 'Tipovi dokumenata',
        labelKey: 'humanResources.catalogs.documentTypes.navLabel',
        path: '/ljudski-resursi/katalozi/tipovi-dokumenata',
        permission: Permissions.HumanResources.Catalogs.Manage,
      },
      {
        label: 'Vrste radnog odnosa',
        labelKey: 'humanResources.catalogs.employmentTypes.navLabel',
        path: '/ljudski-resursi/katalozi/vrste-radnog-odnosa',
        permission: Permissions.HumanResources.Catalogs.Manage,
      },
      {
        label: 'Vrste odsustva',
        labelKey: 'humanResources.catalogs.absenceTypes.navLabel',
        path: '/ljudski-resursi/katalozi/vrste-odsustva',
        permission: Permissions.HumanResources.Catalogs.Manage,
      },
      {
        label: 'Kriterijumi godišnjeg odmora',
        labelKey: 'humanResources.catalogs.leaveEntitlementRules.navLabel',
        path: '/ljudski-resursi/katalozi/kriterijumi-godisnjeg-odmora',
        permission: Permissions.HumanResources.Catalogs.Manage,
      },
      {
        label: 'Kriterijumi plaćenog odsustva',
        labelKey: 'humanResources.catalogs.paidLeaveCriteria.navLabel',
        path: '/ljudski-resursi/katalozi/kriterijumi-placenog-odsustva',
        permission: Permissions.HumanResources.Catalogs.Manage,
      },
      {
        label: 'Razlozi zasnivanja',
        labelKey: 'humanResources.catalogs.employmentStartReasons.navLabel',
        path: '/ljudski-resursi/katalozi/razlozi-zasnivanja',
        permission: Permissions.HumanResources.Catalogs.Manage,
      },
      {
        label: 'Razlozi prestanka',
        labelKey: 'humanResources.catalogs.employmentEndReasons.navLabel',
        path: '/ljudski-resursi/katalozi/razlozi-prestanka',
        permission: Permissions.HumanResources.Catalogs.Manage,
      },
      {
        label: 'Službena zanimanja',
        labelKey: 'humanResources.catalogs.officialJobs.navLabel',
        path: '/ljudski-resursi/katalozi/sluzbena-zanimanja',
        permission: Permissions.HumanResources.Catalogs.Manage,
      },
      {
        label: 'Nacionalnosti',
        labelKey: 'humanResources.catalogs.nationalities.navLabel',
        path: '/ljudski-resursi/katalozi/nacionalnosti',
        permission: Permissions.HumanResources.Catalogs.Manage,
      },
      {
        label: 'Državljanstva',
        labelKey: 'humanResources.catalogs.citizenships.navLabel',
        path: '/ljudski-resursi/katalozi/drzavljanstva',
        permission: Permissions.HumanResources.Catalogs.Manage,
      },
      {
        label: 'Veroispovesti',
        labelKey: 'humanResources.catalogs.religions.navLabel',
        path: '/ljudski-resursi/katalozi/veroispovesti',
        permission: Permissions.HumanResources.Catalogs.Manage,
      },
      {
        label: 'Slave',
        labelKey: 'humanResources.catalogs.patronSaints.navLabel',
        path: '/ljudski-resursi/katalozi/slave',
        permission: Permissions.HumanResources.Catalogs.Manage,
      },
      {
        label: 'Državni praznici',
        labelKey: 'humanResources.catalogs.publicHolidays.navLabel',
        path: '/ljudski-resursi/katalozi/drzavni-praznici',
        permission: Permissions.HumanResources.Catalogs.Manage,
      },
    ],
  },
];
